module.exports = __webpack_public_path__ + "img/logo.74412e07.png";